/** UTF-8 BOM（U+FEFF）。Excel が CSV を Shift_JIS 誤認するのを防ぐ。 */
const UTF8_BOM = String.fromCharCode(0xfeff);

export interface DownloadTextFileOptions {
  /**
   * UTF-8 BOM を先頭に付与する。CSV を Excel で開く際、BOM が無いと Excel が
   * Shift_JIS と誤認して日本語が文字化けするため、CSV では true にする。
   * 絵文字・特殊文字を欠落させずに文字化けを解消できる（Shift_JIS 変換は非採用）。
   */
  bom?: boolean;
}

/**
 * ブラウザでテキストをファイルとしてダウンロードさせる。
 * S-57 のエクスポート（JSON / CSV）で使用。
 *
 * S-88: content はチャンク配列（`toCsvParts` の出力等）も受け付け、そのまま Blob parts に
 * 渡す。巨大 CSV で単一巨大文字列を組み立てず、ピークメモリを抑える。
 */
export function downloadTextFile(
  filename: string,
  content: string | ReadonlyArray<string>,
  mime: string,
  options: DownloadTextFileOptions = {},
): void {
  const parts = typeof content === 'string' ? [content] : [...content];
  const body = options.bom ? [UTF8_BOM, ...parts] : parts;
  const blob = new Blob(body, { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
